<div class="drawer-menu-container bg-white shadow-lg rounded-lg h-full w-100 relative flex flex-col overflow-y-auto overflow-x-hidden">
  <div class="drawer-menu-header sticky top-0 z-20">
    <div class="flex items-center">
      <button
        class="back-button flex items-center justify-center p-2 rounded-full transition duration-200"
        (click)="closeMenu.emit()"
        aria-label="Fechar menu"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <h2 class="drawer-menu-title text-lg font-bold text-gray-900 ml-3">Navegação</h2>
    </div>
  </div>

  <div class="drawer-menu-content flex flex-col items-start justify-start space-y-4">
      <button
          *ngFor="let route of routes"
          class="relative w-full py-3 px-4 rounded-lg flex items-center justify-start shadow-md transition-transform transform hover:scale-105 group"
          [ngClass]="{
              'bg-green-100 border-green-500 border-2 shadow-lg hover:bg-green-200 hover:border-green-700': statusFormularios[route.key],
              'bg-white text-gray-900 hover:bg-gray-800 hover:text-white': !statusFormularios[route.key]
          }"
          (click)="navigateTo(route.getRoute)"
      >
          <div
              class="p-3 rounded-full transition"
              [ngClass]="{
                  'bg-green-700 text-white group-hover:bg-green-800 group-hover:shadow-md': statusFormularios[route.key],
                  'bg-gray-100 text-gray-900 group-hover:bg-gray-700': !statusFormularios[route.key]
              }"
          >
              <mat-icon
                  class="text-2xl transition"
                  [ngClass]="{
                      'text-white': statusFormularios[route.key],
                      'group-hover:text-white': !statusFormularios[route.key]
                  }"
              >
                  {{ statusFormularios[route.key] ? 'check_circle' : route.icon }}
              </mat-icon>
          </div>

          <span class="ml-4 text-base font-medium transition"
              [ngClass]="{
                  'text-green-800 group-hover:text-green-900': statusFormularios[route.key],
                  'group-hover:text-white': !statusFormularios[route.key]
              }"
          >
              {{ route.label }}
          </span>

          <span
              *ngIf="statusFormularios[route.key]"
              class="absolute right-4 px-2 py-1 text-xs font-bold text-white bg-green-600 rounded-full animate-pulse group-hover:bg-green-700"
          >
              Preenchido
          </span>
      </button>
  </div>

  <div class="mt-6">
    <button
        mat-stroked-button
        (click)="gerarRelatorio()"
        class="relative w-full py-3 px-4 rounded-lg flex items-center justify-center shadow-md transition-all duration-300 transform hover:scale-105 group bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        [disabled]="isLoading"
        style="min-height: 50px;" 
    >
        <div class="flex items-center space-x-2 w-full justify-center">
            <mat-icon class="text-xl transition-transform text-white duration-200 group-hover:rotate-12" *ngIf="!isLoading">description</mat-icon>
            <span class="text-base font-medium transition-all duration-200 transform group-hover:scale-105" *ngIf="!isLoading">
                Gerar Relatório
            </span>

            <!-- Spinner com posição absoluta -->
            <div *ngIf="isLoading" class="absolute flex items-center justify-center">
                <mat-progress-spinner
                    color="primary"
                    [mode]="'indeterminate'"
                    diameter="30">
                </mat-progress-spinner>
            </div>
        </div>
    </button>
</div>

